import { useAppConfig } from "../../providers/ConfigProvider";
import { Copyright } from "../Copyright";
import { Logo } from "../Logo";
import { NewsletterForm } from "../NewsletterForm";

import { NavLinks } from "./NavLinks";
import { SocialLinks } from "./SocialLinks";

interface SidebarContentProps {
  compact?: boolean;
}

export function SidebarContent({ compact = false }: SidebarContentProps) {
  const { convertkitFormId } = useAppConfig();
  const logoClassName = compact
    ? "size-30 mt-8 standard-layout-logo"
    : "size-21 mb-3 lg:size-42 lg:mb-0 lg:mt-12 standard-layout-logo";

  const newsletterClassName = compact
    ? "mt-14 max-w-56 order-3"
    : "order-3 hidden mt-14 lg:block";

  const copyrightClassName = compact
    ? "fixed bottom-4 left-0 w-card-sm text-center text-neutral-600 text-xs"
    : "text-center mt-auto mx-auto mb-4 text-neutral-600 text-xs hidden lg:block";

  return (
    <>
      <div className="text-nav-dark flex flex-col items-center">
        <Logo className={logoClassName} />
        <SocialLinks compact={compact} />
        <NavLinks compact={compact} />
        <NewsletterForm
          formId={convertkitFormId}
          className={newsletterClassName}
          formClassName="max-w-51 mx-auto"
        />
      </div>
      <Copyright className={copyrightClassName} />
    </>
  );
}
